var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ResultOption"},on:{"click":function($event){return _vm.$emit('option_selected', _vm.res)}}},[_c('i',{staticClass:"fa-solid fa-magnifying-glass",attrs:{"id":"result_img"}}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }